export default __webpack_public_path__ + "static/GridGain_Logo_Alternate-8e7de63b994dbfc53d7669799016673a.svg";